import { render, staticRenderFns } from "./AiSidebar.vue?vue&type=template&id=1c2041d2"
import script from "./AiSidebar.vue?vue&type=script&lang=js"
export * from "./AiSidebar.vue?vue&type=script&lang=js"
import style0 from "./AiSidebar.vue?vue&type=style&index=0&id=1c2041d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports